import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {
  CategoryInterface, ChatMessageDataInterface,
  DepartmentInterface, MessageDataInterface, ReasonInterface, StandardSolutionInterface,
  TicketActionRequestInterface, TicketCreateRequestInterface,
  TicketDetailsInterface,
  TicketInterface,
  TicketMessageInterface
} from '../interfaces/http.interface';

@Injectable({
  providedIn: 'root'
})
export class SupportApiService {
  private readonly apiBase = 'suppi/supporter/api/v1/customer/tickets';
  private readonly apiBase2 = 'suppi/supporter/api/v1/customer/ticket';

  constructor(private http: HttpClient) {}

  public createTicket(data: TicketCreateRequestInterface): Observable<{ data: TicketDetailsInterface }> {
    return this.http.post<{ data: TicketDetailsInterface }>(`${this.apiBase}`, data);
  }

  public getTickets(): Observable<{ data: TicketInterface[] }> {
    return this.http.get<{ data: TicketInterface[] }>(`${this.apiBase}`);
  }

  public getTicketDetails(ticketId: string): Observable<{ data: TicketDetailsInterface }> {
    return this.http.get<{ data: TicketDetailsInterface }>(`${this.apiBase}/${ticketId}`);
  }

  public sendMessage(ticketId: string, message: TicketMessageInterface): Observable<MessageDataInterface> {
    return this.http.post<MessageDataInterface>(`${this.apiBase}/${ticketId}/messages`, message);
  }

  public getMessages(ticketId: string, page: number): Observable<ChatMessageDataInterface> {
    return this.http.get<ChatMessageDataInterface>(`${this.apiBase}/${ticketId}/messages`, {params: {page: String(page), per_page: '10'}});
  }
  /**
   * Get new messages after specific message UUID (for polling)
   */
  getMessagesAfter(ticketId: string, messageUuid: string): Observable<any> {
    return this.http.get(`${this.apiBase}/${ticketId}/messages`, {
      params: {after: messageUuid}
    });
  }

  public closeTicket(ticketId: string | null, action: TicketActionRequestInterface): Observable<{ data: TicketInterface }> {
    return this.http.put<{ data: TicketInterface }>(`${this.apiBase}/${ticketId}/close`, action);
  }

  public reopenTicket(ticketId: string | null, action: TicketActionRequestInterface): Observable<{ data: TicketInterface }> {
    return this.http.put<{ data: TicketInterface }>(`${this.apiBase}/${ticketId}/reopen`, action);
  }

  public getDepartments(): Observable<{ data: DepartmentInterface[] }> {
    return this.http.get<{ data: DepartmentInterface[] }>(`${this.apiBase2}/departments`);
  }

  public getCategories(departmentId: string): Observable<{ data: CategoryInterface[] }> {
    return this.http.get<{ data: CategoryInterface[] }>(`${this.apiBase2}/departments/${departmentId}/categories`);
  }

  public getReasons(): Observable<{ data: ReasonInterface[] }> {
    return this.http.get<{ data: ReasonInterface[] }>(`${this.apiBase2}/reasons`);
  }

  public getHelpMessage(categoryUUID: string): Observable<{ data: StandardSolutionInterface[] }> {
    return this.http.get<{ data: StandardSolutionInterface[] }>(`${this.apiBase2}/categories/${categoryUUID}/messages`);
  }
}
